// extracted by mini-css-extract-plugin
export default {"FAQ_section":"FAQSection_FAQ_section__Ha-jK","heading":"FAQSection_heading__7PF+i","content_flex":"FAQSection_content_flex__BLC3H","left":"FAQSection_left__B4pKQ"};